import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Section1 from "./Section1";

export default function Indexlogin() {
  return (
    <div>
      <Header />
      <Section1/>
      <Footer />
    </div>
  );
}
